// extracted by mini-css-extract-plugin
export default {"enabled":"StatusLabel_enabled__2HPR7","unavailable":"StatusLabel_unavailable__FAXwj","available":"StatusLabel_available__oi4BH","noBorder":"StatusLabel_noBorder__aFUVN"};